// extracted by css-extract-rspack-plugin
export default {"cls1":"buttonStyles-cls1_HAK","cls2":"buttonStyles-cls2_eOv buttonStyles-cls1_HAK"};